import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useContext } from "react";
import useLocales, { LangType } from "src/hooks/useLocales";

import Context from "../../context";
import OptLanguage from "./OptLanguage";

export default function LanguageSelector() {
	const { actions, state } = useContext(Context);

	const { translate, allLang } = useLocales();

	return (
		<Autocomplete
			getOptionLabel={(option: LangType) => translate(`languages.${option.label}`)}
			onChange={(_event, newValue) => actions.setLanguage(newValue)}
			options={allLang}
			fullWidth
			disableClearable
			sx={{ maxWidth: 350 }}
			renderInput={(params) => (
				<TextField {...params} label={translate("url_panel.select_language")} />
			)}
			renderOption={(props, option) => (
				<li key={option.value} {...props}>
					<OptLanguage {...option} />
				</li>
			)}
			value={state.languageSelected}
		/>
	);
}
